import { Fragment } from 'react';

import type { NavContent, NavElements, valueType } from '@/_types/Shared/Header';
import type { MenusType, SiteType } from '@/_types/Shared/SiteDatas';

import CtaMenu from './CtaMenu';
import LangsMobile from './LangsMobile';
import Menu from './Menu';

export default function NavCardMobile({
	nav,
	site,
	menus,
	ariaAbelledby,
	navType,
	addSeparation,
}: {
	nav: NavContent;
	site: SiteType;
	menus: Partial<MenusType>;
	ariaAbelledby: string;
	navType: string;
	addSeparation: boolean;
}) {
	const elements: NavElements = nav.elements;

	let menuClass = {};
	let menuCtaClass = '';

	if (navType === 'topNav') {
		menuClass = {
			menuItems: 'minos-header-topnav-menuItems text-base tablet:minos-header-topnav-menuItems',
			childMenuItems:
				'minos-header-topnav-childMenuItems text-base tablet:minos-header-topnav-childMenuItems',
			menuChildBg: 'bg-minos-header-topnav-menuchild-bg',
			menuChildRadius: 'rounded-minos-header-topnav-menuchild-radius',
			iconColor: 'text-minos-header-topnav-icon-color',
			menuChildSvg: 'fill-minos-header-topnav-menuchild-bg',
		};
		menuCtaClass = 'minos-header-topnav-cta tablet:minos-header-topnav-cta';
	} else {
		menuClass = {
			menuItems: 'minos-header-mainnav-menuItems text-base tablet:minos-header-mainnav-menuItems',
			childMenuItems:
				'minos-header-mainnav-childMenuItems text-base tablet:minos-header-mainnav-childMenuItems',
			menuChildBg: 'bg-minos-header-mainnav-menuchild-bg',
			menuChildRadius: 'rounded-minos-header-mainnav-menuchild-radius',
			iconColor: 'text-minos-header-mainnav-icon-color',
			menuChildSvg: 'fill-minos-header-mainnav-menuchild-bg',
		};
		menuCtaClass = 'minos-header-mainnav-cta tablet:minos-header-mainnav-cta';
	}

	const iconCTA = nav.types.cta?.btnHasIcon ? nav.types.cta?.btnHasIcon : false;
	const decoCTA = nav.types.cta?.btnDecorationElement ? nav.types.cta?.btnDecorationElement : 'long';
	const variantMenuChildItems = nav.types.variantMenuChildItems;

	const contentType: any = {
		primary_menu: (
			<Menu
				menu={menus.primary_menu}
				itemClass={menuClass}
				variantMenuChildItems={variantMenuChildItems}
				addSeparation={addSeparation}
			/>
		),
		secondary_menu: (
			<Menu
				menu={menus.secondary_menu}
				itemClass={menuClass}
				variantMenuChildItems={variantMenuChildItems}
				addSeparation={addSeparation}
			/>
		),
		cta_menu: (
			<CtaMenu CTAMenu={menus.cta_menu} itemClass={menuCtaClass} icon={iconCTA} deco={decoCTA} />
		),
		lang_menu: <LangsMobile langs={site.langs} itemClass={menuClass} />,
	};

	return (
		<nav aria-labelledby={ariaAbelledby} className='flex flex-col gap-2'>
			{elements.left && elements.left.length > 0 && (
				<div className='flex flex-col items-center gap-10'>
					{elements.left.map((item: valueType) => (
						<Fragment key={item.id}>
							{item.value != 'custom_logo' && item.value != 'secondary_logo' && item.value != 'search' && (
								<>{contentType[item.value]}</>
							)}
						</Fragment>
					))}
				</div>
			)}

			{elements.center && elements.center.length > 0 && (
				<div className='flex flex-col items-center gap-10'>
					{elements.center.map((item: valueType) => (
						<Fragment key={item.id}>
							{item.value != 'custom_logo' && item.value != 'secondary_logo' && item.value != 'search' && (
								<>{contentType[item.value]}</>
							)}
						</Fragment>
					))}
				</div>
			)}

			{elements.right && elements.right.length > 0 && (
				<div className='flex flex-col items-center gap-10'>
					{elements.right.map((item: valueType) => (
						<Fragment key={item.id}>
							{item.value != 'custom_logo' && item.value != 'secondary_logo' && item.value != 'search' && (
								<>{contentType[item.value]}</>
							)}
						</Fragment>
					))}
				</div>
			)}
		</nav>
	);
}
